import { createSlice } from "@reduxjs/toolkit";

const applyAgentPendingSlice = createSlice({
    name: 'applyAgentPending',
    initialState: {
        count: 0,
    },
    reducers: {
        applyAgentPendingHandler: (state,action) => {
            state.count = action.payload
        }
    }
});

export const {applyAgentPendingHandler} = applyAgentPendingSlice.actions;
export default applyAgentPendingSlice.reducer;